import React, { useState } from 'react';
import { CostProduct } from '../types/costwand.d';
import { useCosts } from '../hooks/useCosts.ts';
import CostTable from '../components/CostTable.tsx';
import { Button } from '../components/ui/button.tsx';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
  DialogFooter,
} from '../components/ui/dialog.tsx';

const CostsPage = () => {
  const {
    costs,
    loading,
    error,
    currentPage,
    totalPages,
    totalItems,
    handlePageChange,
    // Assuming no create/update/delete for costs directly from this page,
    // as costs are typically derived from products or composites.
    // If there were, they would be implemented here.
  } = useCosts();

  // No form or editing functionality for costs page as they are usually read-only representations.

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-secondary-foreground">Product Costs</h2>
        {/* No "Add New Cost" button as costs are derived */}
      </div>

      <CostTable
        costs={costs}
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        loading={loading}
        error={error}
        baseEndpoint="/costs" // NEW: Pass the base endpoint
      />
    </div>
  );
};

export default CostsPage;